import { Box, Container, Stack, Typography } from '@mui/material'

const Banner = (props: { banner: string, subBanner: string }) => {
  return (
    <Box sx={{ height: "600px", display: "flex", margin: "20px" }} alignItems="center" justifyContent="center">
      <Stack spacing={10} alignItems="center">
        <Typography variant='h1' textAlign="center">
          {props.banner}
        </Typography>
        <Container maxWidth="sm">
          <Typography textAlign="center" >
            {props.subBanner}
          </Typography>
        </Container>
      </Stack>
    </Box>
  )
}

export default Banner
